import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * Quotation requisition reject
 *
 * @param  {object}
 */

const quotationReject = (payload) =>
  Vue.$http.post(`purchase/quotation/reject/`, payload)
    .then()
    .catch(err => {
      throw err
    })

export default quotationReject


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/quotationReject.js